/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2012 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { userTypes } from '../../login/login.config';
import { basecode } from '../ehr/subs/basecode';
import { Iceutility } from '../../services/iceutility';

export class limitobject extends IceEntity {
  count: number = 0;
  limit_type: IceTypes.LIMITTYPE = IceTypes.LIMITTYPE.ltNone;
  excess_rate: number = 0.0;

  gettablename(): string {
    return "LIMIT";
  }
}

export class feeobject extends IceEntity {
  fee_key: string = "";
  amount: number = 0.0;
  description: string = "";

  gettablename(): string {
    return "FEE";
  }
}

export class licenseobject extends IceEntity {
  license_id: number = 0;
  license_key: string = "";
  license_type: userTypes.USER_FEATURES;
  title: string = "";
  description: string = "";
  rate: number = 0.0;
  unit_of_rate: IceTypes.RATEUNITS = IceTypes.RATEUNITS.ruPerMonth;
  length_of_term: number = 0;
  trial: boolean = false;
  license_agreement: string = "";
  disabled: boolean = false;
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  introduction: string = "";
  benefits: string = "";
  features: string = "";
  upgrade_level: number = 0;
  license_sequence: number = 0;

  LIMITS: limitobject[] = [];
  FEES: feeobject[] = [];
  FEATURE_DETAILS: basecode[] = [];
  COUNTRIES: basecode[] = [];
  CURRENCIES: basecode[] = [];

  gettablename(): string {
    return "LICENSE";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "LIMITS") return true;
    else if (ColumnName == "FEES") return true;
    else if (ColumnName == "FEATURE_DETAILS") return true;
    else if (ColumnName == "COUNTRIES") return true;
    else if (ColumnName == "CURRENCIES") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "LIMITS") return "LIMIT";
    else if (ColumnName == "FEES") return "FEE";
    else if (ColumnName == "FEATURE_DETAILS") return "FEATURE_DETAIL";
    else if (ColumnName == "COUNTRIES") return "COUNTRY";
    else if (ColumnName == "CURRENCIES") return "CURRENCY";
    
    return null;
  }

  getPriceSummary(): string {
    let sum: string = "";
    try {
      sum = this.rate.toString() + " " + licenseobject.getRateUnitsToText(this.unit_of_rate);
    }
    catch(e)
    {
      console.log(e);
    }
    return sum;
  }

  static getRateUnitsToText(runits: IceTypes.RATEUNITS): string {
    let txt: string = "";
    switch (Iceutility.toLong(runits)) {
      case IceTypes.RATEUNITS.ruPerDay:
        txt = "per./day";
        break;
      case IceTypes.RATEUNITS.ruPerWeek:
        txt = "per./wk.";
        break;
      case IceTypes.RATEUNITS.ruPerMonth:
        txt = "per./mo.";
        break;
      case IceTypes.RATEUNITS.ruPerYear:
        txt = "per./yr.";
        break;
      case IceTypes.RATEUNITS.ruPerHalfYear:
        txt = "per./6 mo.";
        break;
    }
    return txt;
  }

  public static getLimitText(lt: IceTypes.LIMITTYPE): string {
    let text: string = "";
    try {
      switch (Iceutility.toLong(lt)) {
        case IceTypes.LIMITTYPE.ltUser:
          text = "User(s)";
          break;
        case IceTypes.LIMITTYPE.ltPatient:
          text = "Patient(s)";
          break;
        case IceTypes.LIMITTYPE.ltTransaction:
          text = "Transaction(s)";
          break;
        case IceTypes.LIMITTYPE.ltData:
          text = "Data (MB)";
          break;
        case IceTypes.LIMITTYPE.ltProvider:
          text = "Provider(s)";
          break;
      }
    }
    catch (e) {
      console.log(e)
    }
    return text;
  }

  public getLengthOfTerms() {
    let lenofterms: string = "";
    let units: string = "";
    switch (Iceutility.toLong(this.unit_of_rate)) {
      case IceTypes.RATEUNITS.ruPerDay:
        units = "Day(s)";
        break;
      case IceTypes.RATEUNITS.ruPerMonth:
        units = "Month(s)";
        break;
      case IceTypes.RATEUNITS.ruPerWeek:
        units = "Week(s)";
        break;
      case IceTypes.RATEUNITS.ruPerYear:
        units = "Year(s)";
        break;
    }

    let len = this.length_of_term != null ? this.length_of_term.toString() : 1;
    try {
      lenofterms = "Terms: " + this.length_of_term.toString() + "-" + units;
    }
    catch
    {
      lenofterms = "";
    }
    return lenofterms;
  }

  getSummary(): string[]{
    let sums = [];
    for (let iLmt = 0; iLmt < this.LIMITS.length; iLmt++) {
      let lmt = this.LIMITS[iLmt];
      if (lmt == null) continue;

      let limit = lmt.count < 0 ? "Unlimited" : lmt.count.toString();
      sums.push(limit + " " + licenseobject.getLimitText(lmt.limit_type));
    }

    sums.push(this.getPriceSummary());
    sums.push(this.getLengthOfTerms());
    return sums;
  }
}
